/* eslint-disable react/forbid-elements */
import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { DisplayMarkdown } from '../../common/markdown/DisplayMarkdown';
import { PanelBody, PanelHeading } from '../../elements';
import { ConditionScoreLabel } from '../../utils/ConditionScoreLabel';

interface ISummeryAndAdviceProps extends ITranslateProps {
    condition: string | undefined;
    summaryAndAdvice: string | undefined;
}

class SummeryAndAdvice extends React.Component<ISummeryAndAdviceProps, Record<string, unknown>> {
    constructor(props: ISummeryAndAdviceProps) {
        super(props);

        this.state = {};
    }

    public override render() {
        return (
            <div id="SummaryAndAdvice" className="panel">
                <PanelHeading text={this.props.t('survey.summaryAndAdvice')} icon="fa fa-file-text-o">
                    <ConditionScoreLabel value={this.props.condition} />
                </PanelHeading>
                <PanelBody whiteBackground={true}>
                    <DisplayMarkdown markdown={this.props.summaryAndAdvice} />
                </PanelBody>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(SummeryAndAdvice);
